/** @format */

import React, { useEffect, useState } from 'react';
import I18n from '../../../components/Translate/I18n';

const WelcomeSmsLegend = (): React.ReactElement => {
    return (
        <div>
            <div>{`{{country_usage}} - zużycie w kraju`}</div>
            <div>{`{{roaming_usage}} - zużycie w roamingu`}</div>
            <div>{`{{country_usage_unit}} - jednostka zużycia dla kraju`}</div>
            <div>{`{{roaming_usage_unit}} - jednostka zużycia dla roamingu`}</div>
            <div>{`{{country_usage_expiry_date}} - data ważności zużycia w kraju`}</div>
            <div>{`{{roaming_usage_expiry_date}} - data ważności zużycia w roamingu`}</div>
            <div>{`{{outgoing_price}} - cena za połączenia wykonywane`}</div>
            <div>{`{{incoming_price}} - cena za połączenie odebrane`}</div>
            <div>{`{{data_transfer_price}} - cena za transmisję danych`}</div>
            <div>{`{{mms_price}} - cena za MMS`}</div>
            <div>{`{{sms_price}} - cena za SMS`}</div>
        </div>
    );
};

export default WelcomeSmsLegend;
